export default __webpack_public_path__ + "static/media/pinterest.600ad45a.svg";